import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const Root = styled("div")(({ theme }) => ({
  textAlign: "center",
  [theme.breakpoints.up("mobile")]: {
    padding: "0 134px",
  },
}));

export const Title = styled(Typography)({
  marginBottom: 35,
});
